export const LOGGED_IN_SESSION_KEY = "LOGGED_IN";
export const ACCESS_TOKEN_KEY = "ACCESS_TOKEN";
export const REFRESH_TOKEN_KEY = "REFRESH_TOKEN";
export const EXCEL_FILE_TYPE =
  ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
export const BY_MY = ["M", "Y"];
export const DOWNLOADED_EXCEL_FILE_TYPE = "application/vnd.ms-excel";
export const PRAAS_SYSTEM = "PRAAS_SYSTEM";
export const WORKFLOW_SYSTEM = "WORKFLOW_SYSTEM";
export const PROPERTIES_SCIENCE = "PROPERTIES_SCIENCE";
export const NO_DATA_TEXT = "No data";
export const BUILDING_SEGMENT_NAMES = [
  "Office",
  "Residential",
  "Logistic",
  "Retail",
  "Hospitality",
  "Data centers",
];
export const AREA_TYPES = ["SQFT", "SQM"];
export const BUILDING_SEGMENTS = [
  "OFFICE",
  "RESIDENTIAL",
  "LOGISTIC",
  "RETAIL",
  "HOSPITALITY",
  "DATA-CENTERS",
];
export const MAIN_SYSTEMS = [PRAAS_SYSTEM, WORKFLOW_SYSTEM, PROPERTIES_SCIENCE];
